import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';
import { ModelName, PopupEvent } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';

import type TemplateRecord from 'webapp/models/template';

export default class BoardsPublicTemplatesTemplateRoute extends Route {
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('model-manager/board-loops')
	declare mmBoardLoopsService: Service.ModelManager.BoardLoops;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('popup') declare popupService: Service.Popup;
	@service('store') declare storeService: Service.Store;
	@service('request') declare requestService: Service.Request;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};
		// make sure request for templates has finished before we go search for model
		promises.templates = this.mmTemplatesService.requestBoardPublicTemplates();
		promises.boardLoopTemplates = this.mmTemplatesService.requestBoardLoopPublicTemplates();

		return hashSettled(promises);
	}

	override model(params: { template_id: string }): TemplateRecord | void {
		let model;

		if (params) {
			model = this.storeService.peekRecord(
				ModelName.TEMPLATE,
				params.template_id,
			) as TemplateRecord;
		}

		if (!model) {
			this.navigationService.replaceRoute('boards.public-templates');
			return;
		}

		return model;
	}

	override afterModel(model: TemplateRecord): void {
		this.openBoardAndLoopPreviewPopup(model);
	}

	private openBoardAndLoopPreviewPopup = (templateRecord: TemplateRecord): void => {
		const templateModel = this.mmTemplatesService.createModel(templateRecord);

		this.mmTemplatesService.trackEvent(templateModel, TrackingEvent.TEMPLATE_PREVIEW);

		const popup = this.mmBoardsService.createAndOpenPreviewPopup({
			template: templateModel,
			trackingOrigin: null,
			onTemplateUse: () => {
				this.navigationService.transitionToRoute(
					'boards.public-templates.template.connect',
					templateRecord,
				);
			},
		});

		popup.on(PopupEvent.CLOSING, this, () => {
			this.navigationService.transitionToRoute('boards.public-templates');
		});
	};
}
